export default "__VITE_ASSET__CGZ7lu8d__"